import React from "react";

// A minimal SVG completion ring used in the worksheet header. Renders the
// completion percentage as an arc + centered numeric label. Kept intentionally
// simple (no external chart lib) so it works on server-rendered previews.
export default function ProgressRing({
  value = 0,
  size = 56,
  stroke = 6,
  label = null,
}) {
  const clamped = Math.max(0, Math.min(100, Number(value) || 0));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (clamped / 100) * c;
  const displayLabel = label != null ? label : `${Math.round(clamped)}%`;

  return (
    <div
      data-testid="workbook-progress-ring"
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
      aria-label={`Completion ${Math.round(clamped)}%`}
    >
      <svg width={size} height={size} className="rotate-[-90deg]">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="hsl(var(--border))"
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          fill="none"
          strokeDasharray={c}
          strokeDashoffset={offset}
          className="text-[color:var(--brand-accent,#E91E63)] transition-[stroke-dashoffset] duration-500 ease-out"
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center text-[11px] font-semibold tracking-tight">
        {displayLabel}
      </div>
    </div>
  );
}
